import React, { useState } from 'react';
import { Chart } from '../../Organisms/';
import { Icon, Button, DatePicker } from '../../Atoms';
import { Input } from '../../Molecules';
import { Col, Row } from 'react-bootstrap';
import { DEMANDE_COLOR, DEMANDE_FROM, red } from '../../Config/Config';
import PropTypes from 'prop-types';
import { apiDownloadDocument } from '../../Api/Contact/Contact';

function OrganismDemandeCardDetail (props) {
  const [errors, setErrors] = useState({});
  const downloadDocument = async(documentId)=>{
      try {
        setErrors({});
        const response = await apiDownloadDocument(documentId);
        if (response.status==200) {
          const document = await createBlob(response.base64pdf,response.mimeType)
          if (document.url) {
               window.open(document.url,"_blank")
           }
        }else{
          console.log(response.errors[0]);
          setErrors((prevErrors) => ({
            ...prevErrors,
            [documentId]: response.errors[0], // Store error with documentId
          }));
        }
      } catch (error) {
      }
  }

  const createBlob = async (data,mimeType) => {
    try {
      const blob = await (
        await fetch(`data:${mimeType};base64,${data}`)
      ).blob();
      const url = URL.createObjectURL(blob);
      return { blob, url };
    } catch (err) {}
  };
  const renderDocument = document => {
    if (document?.length) {
      return (
        <>
          {document.map((element, index) => {
            return (
              <>
                <div
                  className='demande-card-detail-document-container'
                  key={index}
                  onClick={()=>downloadDocument(element.id)}
                  style={{cursor:'pointer'}}
                >
                  <div style={{flex: 0, paddingRight: 8}}>
                    <Icon icon='FolderFacture' size={12} />
                  </div>
                  <div style={{flex: 0}}>
                    <span style={{whiteSpace: 'nowrap'}}>{element.name}</span>
                  </div>
                </div>

                {errors[element.id] && <p className="errorMessage">{errors[element.id]}</p>}
              </>
            );
          })}
        </>
      );
    }
    return null;
  };
  const getOrder = index => {
    if (index % 2) {
      return 1;
    } else {
      return 2;
    }
  };
  const content = (data, index) => {
    const order = getOrder(index);
    const containerClassName = ['demande-card-detail-content-container'];
    if (data.from == "SPVIE") {
      containerClassName.push('flex-reverse');
    }
    let fromColor = DEMANDE_FROM.find(el => el.from == data.from).color;
    fromColor = fromColor == undefined ? 'white' : fromColor;
    return (
      <div className={containerClassName.join(' ')} key={index}>
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: '10px' }}>{data.date}</div>
          <div className=''>{data.description}</div>
          <div className='demande-card-detail-document'>
            {renderDocument(data.attachments)}
          </div>
        </div>
        <div className={data.from == "SPVIE" ? `demande-card-detail-image-margin-1`: `demande-card-detail-image-margin-2`}>
          <div
            className='demande-card-detail-image'
            style={{ backgroundColor: fromColor }}
          >
            {data.from}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='demande-card-detail-container'>
      {props.data.map((element, index) => {
        return content(element, index);
      })}
    </div>
  );
}
OrganismDemandeCardDetail.PropTypes = {
  data: PropTypes.array
};
export default OrganismDemandeCardDetail;
